import { formatConstraintLabel } from '../helpers/constraintHelpers';

const ConstraintTags = ({ constraints }) => {
    if (!constraints?.length) return null;

    return (
        <div className="constraint-tags">
            {constraints.map((constraint, index) => (
                <span key={index} className="constraint-tag">
                    <span className="constraint-tag-label">{formatConstraintLabel(constraint)}</span>
                </span>
            ))}
        </div>
    );
};

export default ConstraintTags;
